import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
// Logo-வை இங்கே இம்போர்ட் செய்கிறோம்
import LogoImg from '../assets/LOGO.png';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const location = useLocation();

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Contact', path: '/contact' },
    ];

    const services = [
        { name: 'Interior Painting', path: '/services/interior' },
        { name: 'Exterior Painting', path: '/services/exterior' },
        { name: 'Wood & Polishing', path: '/services/wood' },
        { name: 'Texture Designs', path: '/services/texture' },
        { name: 'Waterproofing', path: '/services/waterproofing' },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <nav className="bg-white shadow-md sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-20 items-center">

                    {/* Brand / Logo Section */}
                    <Link to="/" className="flex items-center space-x-3 group">
                        {/* Round Logo Container */}
                        <div className="relative w-12 h-12 sm:w-14 sm:h-14 overflow-hidden rounded-full border-2 border-orange-500 shadow-sm group-hover:scale-105 transition-transform duration-300 bg-white">
                            <img
                                src={LogoImg}
                                alt="SSS Home Painting Logo"
                                className="w-full h-full object-cover"
                            />
                        </div>

                        <div className="flex flex-col">
                            <span className="font-extrabold text-xl sm:text-2xl text-blue-900 leading-none tracking-tight">SSS</span>
                            <span className="text-[10px] sm:text-[11px] font-bold tracking-[0.15em] text-orange-600 uppercase">Home Painting</span>
                        </div>
                    </Link>

                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-8">
                        {navLinks.map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className={`font-bold transition-colors ${isActive(link.path) ? 'text-orange-600' : 'text-blue-900 hover:text-orange-600'}`}
                            >
                                {link.name}
                            </Link>
                        ))}

                        {/* Services Dropdown */}
                        <div
                            className="relative group"
                            onMouseEnter={() => setIsServicesOpen(true)}
                            onMouseLeave={() => setIsServicesOpen(false)}
                        >
                            <button
                                className={`flex items-center space-x-1 font-bold transition-colors py-8 ${location.pathname.includes('/services') ? 'text-orange-600' : 'text-blue-900 hover:text-orange-600'}`}
                            >
                                <span>Services</span>
                                <ChevronDown size={16} className={`transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`} />
                            </button>

                            <div
                                className={`absolute left-0 mt-0 w-60 bg-white rounded-b-xl shadow-2xl py-3 border-t-2 border-orange-500 transition-all duration-300 ${isServicesOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`}
                            >
                                {services.map((service) => (
                                    <Link
                                        key={service.path}
                                        to={service.path}
                                        className={`block px-5 py-3 text-sm font-bold transition-colors ${isActive(service.path) ? 'bg-orange-50 text-orange-600' : 'text-gray-700 hover:bg-orange-50 hover:text-orange-600'}`}
                                        onClick={() => setIsServicesOpen(false)}
                                    >
                                        {service.name}
                                    </Link>
                                ))}
                            </div>
                        </div>

                        <Link
                            to="/contact"
                            className="bg-blue-900 text-white px-7 py-3 rounded-full font-bold hover:bg-orange-600 transition-all shadow-lg hover:shadow-orange-200 active:scale-95"
                        >
                            Get Free Quote
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="text-blue-900 p-2 focus:outline-none"
                            aria-label="Toggle Menu"
                        >
                            {isOpen ? <X size={30} className="text-orange-600" /> : <Menu size={30} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div className={`md:hidden absolute w-full bg-white border-t border-slate-100 shadow-2xl transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[100vh] opacity-100 visible' : 'max-h-0 opacity-0 invisible overflow-hidden'}`}>
                <div className="py-6 px-6 space-y-5">
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={`block text-xl font-black tracking-tight ${isActive(link.path) ? 'text-orange-600' : 'text-blue-900'}`}
                            onClick={() => setIsOpen(false)}
                        >
                            {link.name}
                        </Link>
                    ))}

                    <div className="pt-4 border-t border-slate-100">
                        <p className="text-[11px] font-black text-gray-400 uppercase tracking-[0.2em] mb-4">Our Painting Expertise</p>
                        <div className="grid grid-cols-1 gap-4">
                            {services.map((service) => (
                                <Link
                                    key={service.path}
                                    to={service.path}
                                    className={`font-bold text-lg ${isActive(service.path) ? 'text-orange-600' : 'text-gray-700'}`}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {service.name}
                                </Link>
                            ))}
                        </div>
                    </div>

                    <Link
                        to="/contact"
                        className="block w-full text-center bg-blue-900 text-white py-4 rounded-2xl font-black text-lg shadow-xl"
                        onClick={() => setIsOpen(false)}
                    >
                        Call: +91 80721 27022
                    </Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;